;(function () {
  const playVideo = (slider) => {
    if (!slider || !slider.slides) return

    // Pause previous slide videos
    if (slider.slides[slider.previousIndex]) {
      const prev = slider.slides[slider.previousIndex]
      prev.querySelectorAll('.media-grid__video video').forEach((v) => v.pause())
      prev.querySelectorAll('.media-grid__video iframe').forEach((iframe) => {
        if (iframe.classList.contains('js-youtube')) {
          iframe.contentWindow.postMessage('{"event":"command","func":"pauseVideo","args":""}', '*')
        } else if (iframe.classList.contains('js-vimeo')) {
          iframe.contentWindow.postMessage('{"method":"pause"}', '*')
        }
        iframe.classList.add('video-pause')
        iframe.classList.remove('video-play')
      })
    }

    // Play active slide videos
    if (slider.slides[slider.activeIndex]) {
      const active = slider.slides[slider.activeIndex]
      active.querySelectorAll('.media-grid__video.autoplay video').forEach((v) => {
        v.autoplay = true
        if (v.paused) v.play()
      })
      active.querySelectorAll('.media-grid__video.autoplay iframe').forEach((iframe) => {
        if (iframe.classList.contains('js-youtube')) {
          iframe.contentWindow.postMessage('{"event":"command","func":"playVideo","args":""}', '*')
          iframe.contentWindow.postMessage(
            iframe.classList.contains('video-muted')
              ? '{"event":"command","func":"mute","args":""}'
              : '{"event":"command","func":"unMute","args":""}', '*'
          )
        } else if (iframe.classList.contains('js-vimeo')) {
          iframe.contentWindow.postMessage('{"method":"play"}', '*')
          iframe.contentWindow.postMessage(
            iframe.classList.contains('video-muted')
              ? '{"method":"setVolume","value":0}'
              : '{"method":"setVolume","value":1}', '*'
          )
        }
        iframe.classList.add('video-play')
        iframe.classList.remove('video-pause')
      })

      // Reset play buttons
      active.querySelectorAll('.js-play-video').forEach((btn) => btn.classList.remove('active'))
    }
  }

  const stopVideo = (slider) => {
    if (!slider || !slider.slides || !slider.slides[slider.activeIndex]) return
    const active = slider.slides[slider.activeIndex]
    active.querySelectorAll('.media-grid__video video').forEach((v) => v.pause())
    active.querySelectorAll('.media-grid__video iframe').forEach((iframe) => {
      if (iframe.classList.contains('js-youtube')) {
        iframe.contentWindow.postMessage('{"event":"command","func":"pauseVideo","args":""}', '*')
      } else if (iframe.classList.contains('js-vimeo')) {
        iframe.contentWindow.postMessage('{"method":"pause"}', '*')
      }
      iframe.classList.add('video-pause')
      iframe.classList.remove('video-play')
    })
  }

  const controlsVideo = () => {
    document.querySelectorAll('.media-grid-section').forEach((section) => {
      section.querySelectorAll('.js-play-video').forEach((button) => {
        button.onclick = () => {
          const panel = button.closest('.media-grid__panel')
          if (!panel) return
          const video = panel.querySelector('.media-grid__video video')
          if (video) {
            video.paused ? video.play() : video.pause()
            button.classList.toggle('active')
          }
          const iframe = panel.querySelector('.media-grid__video iframe')
          if (iframe) {
            if (iframe.classList.contains('video-pause')) {
              if (iframe.classList.contains('js-youtube'))
                iframe.contentWindow.postMessage('{"event":"command","func":"playVideo","args":""}', '*')
              else if (iframe.classList.contains('js-vimeo'))
                iframe.contentWindow.postMessage('{"method":"play"}', '*')
              iframe.classList.add('video-play')
              iframe.classList.remove('video-pause')
            } else {
              if (iframe.classList.contains('js-youtube'))
                iframe.contentWindow.postMessage('{"event":"command","func":"pauseVideo","args":""}', '*')
              else if (iframe.classList.contains('js-vimeo'))
                iframe.contentWindow.postMessage('{"method":"pause"}', '*')
              iframe.classList.add('video-pause')
              iframe.classList.remove('video-play')
            }
            button.classList.toggle('active')
          }
        }
      })

      section.querySelectorAll('.js-sound-video').forEach((button) => {
        button.onclick = () => {
          const panel = button.closest('.media-grid__panel')
          if (!panel) return
          const video = panel.querySelector('.media-grid__video video')
          if (video) {
            video.muted = !video.muted
            button.classList.toggle('active')
          }
          const iframe = panel.querySelector('.media-grid__video iframe')
          if (iframe) {
            if (iframe.classList.contains('video-muted')) {
              if (iframe.classList.contains('js-youtube'))
                iframe.contentWindow.postMessage('{"event":"command","func":"unMute","args":""}', '*')
              else if (iframe.classList.contains('js-vimeo'))
                iframe.contentWindow.postMessage('{"method":"setVolume","value":1}', '*')
              iframe.classList.remove('video-muted')
            } else {
              if (iframe.classList.contains('js-youtube'))
                iframe.contentWindow.postMessage('{"event":"command","func":"mute","args":""}', '*')
              else if (iframe.classList.contains('js-vimeo'))
                iframe.contentWindow.postMessage('{"method":"setVolume","value":0}', '*')
              iframe.classList.add('video-muted')
            }
            button.classList.toggle('active')
          }
        }
      })
    })
  }

  const initSliders = () => {
    document.querySelectorAll('.media-grid-section').forEach((section) => {
      const slider = section.querySelector('.media-grid__slider:not(.swiper-initialized)')
      const pagination = section.querySelector('.media-grid__pagination')
      const nextBtn = section.querySelector('.swiper-button-next')
      const prevBtn = section.querySelector('.swiper-button-prev')

      if (!slider) return

      const isAutoplay = !!slider.getAttribute('data-autoplay')
      const isLoop = !!slider.getAttribute('data-loop')

      const swiperInstance = new Swiper(slider, {
        slidesPerView: 1,
        allowTouchMove: true,
        speed: 1500,
        loop: isLoop,
        autoHeight: true,
        autoplay: isAutoplay ? { disableOnInteraction: true } : false,
        pagination: {
          el: pagination,
          type: 'bullets',
          clickable: true,
          renderBullet: function (_, className) {
            return '<span class="' + className + '"><svg width="16" height="16" viewBox="0 0 16 16" fill="currentColor"><circle class="circle" cx="8" cy="8" r="7" stroke="currentColor"/></svg></span>'
          },
        },
        navigation: {
          nextEl: nextBtn,
          prevEl: prevBtn,
        },
      })

      swiperInstance.on('slideChange', function () {
        playVideo(swiperInstance)
      })
    })
  }

  const initSection = () => {
    document.querySelectorAll('.media-grid-section').forEach((section) => {
      const observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          const slider = entry.target.querySelector('.media-grid__slider')
          if (!slider || !slider.swiper) return
          if (entry.isIntersecting) {
            playVideo(slider.swiper)
          } else {
            stopVideo(slider.swiper)
          }
        })
      })
      observer.observe(section)
    })
  }

  setTimeout(() => {
    initSliders()
    controlsVideo()
    initSection()
  }, 100)

  document.addEventListener('shopify:section:load', function () {
    initSliders()
    controlsVideo()
    initSection()
  })

  window.addEventListener('focus', () => {
    document.querySelectorAll('.media-grid-section').forEach((section) => {
      const slider = section.querySelector('.media-grid__slider')
      if (slider && slider.swiper) playVideo(slider.swiper)
    })
  })

  window.addEventListener('blur', () => {
    document.querySelectorAll('.media-grid-section').forEach((section) => {
      const slider = section.querySelector('.media-grid__slider')
      if (slider && slider.swiper) stopVideo(slider.swiper)
    })
  })
})()
